import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';
import { DEFAULT_HEADER, DEFAULT_ICON, DEFAULT_NAV } from 'src/config';

// 2. Type for context value
type LayoutContextType = {
  headerLayout: typeof DEFAULT_HEADER;
  navLayout: typeof DEFAULT_NAV;
  iconLayout: typeof DEFAULT_ICON;
  setHeaderLayout: Dispatch<SetStateAction<typeof DEFAULT_HEADER>>;
  setNavLayout: Dispatch<SetStateAction<typeof DEFAULT_NAV>>;
  setIconLayout: Dispatch<SetStateAction<typeof DEFAULT_ICON>>;
};

const initialState: LayoutContextType = {
  headerLayout: DEFAULT_HEADER,
  navLayout: DEFAULT_NAV,
  iconLayout: DEFAULT_ICON,
  setHeaderLayout: () => {},
  setNavLayout: () => {},
  setIconLayout: () => {},
};

const LayoutContext = createContext<LayoutContextType>(initialState);

// eslint-disable-next-line react-refresh/only-export-components
export const useLayout = () => useContext(LayoutContext);

interface LayoutProviderProps {
  children: React.ReactNode;
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  const [headerLayout, setHeaderLayout] = useState<typeof DEFAULT_HEADER>(DEFAULT_HEADER);
  const [navLayout, setNavLayout] = useState<typeof DEFAULT_NAV>(DEFAULT_NAV);
  const [iconLayout, setIconLayout] = useState<typeof DEFAULT_ICON>(DEFAULT_ICON);

  const value = {
    headerLayout,
    setHeaderLayout,
    navLayout,
    setNavLayout,
    iconLayout,
    setIconLayout,
  };

  return <LayoutContext.Provider value={value}> {children} </LayoutContext.Provider>;
};
